import React, { useMemo } from 'react';
import { getCurrencyLogo } from '@/utils/global';
import { useSelector } from 'react-redux';

import InputComponent from '@/components/common-components/InputComponent/InputComponent';
import RequiredAsterisk from '@/components/common-components/RequiredAsterisk/RequiredAsterisk';

interface Props {
  label?: string;
  isRequired?: boolean;
  maxAmount?: number;
  amount: number | null;
  setAmount: React.Dispatch<React.SetStateAction<number | null>>;
  disabled?: boolean;
}

const AmountInput: React.FC<Props> = ({
  label = 'Enter Amount',
  isRequired = true,
  maxAmount = 0,
  amount,
  setAmount,
  disabled = false,
}) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const currencyLogo = getCurrencyLogo(userDetails?.defaultCurrency);

  const isError = useMemo(() => {
    if (maxAmount && amount && amount > maxAmount) {
      return `Payment amount can’t be more than ${currencyLogo}${maxAmount}`;
    }
    return false;
  }, [amount, maxAmount]);

  return (
    <div>
      <label htmlFor="amount-input" className="text-sm font-normal text-subdued mb-2">
        {label} {isRequired && <RequiredAsterisk />}
      </label>
      <div className="automation-amount-input-container">
        <span className="text-base font-normal text-default w-10 h-10 flex center items-center border-default rounded">
          {currencyLogo}
        </span>
        <InputComponent
          containerClassName="h-10"
          type="number"
          inputWrapperStyle={{
            borderColor: isError ? 'var(--border-critical)' : 'var(--border-default)',
          }}
          value={amount ? amount.toString() : ''}
          placeholder="Enter amount to pay eg. 100"
          onChange={(e) => {
            setAmount(Number(e.target.value));
          }}
          onBlur={() => {
            if (amount && amount > maxAmount) {
              setAmount(maxAmount);
            }
          }}
          disabled={disabled}
        />
      </div>
      {isError && <p className="text-danger text-xs font-normal mt-1">{isError}</p>}
    </div>
  );
};

export default AmountInput;
